import snackbarReducer from './snackbarReducer';
import scriptsReducer from './scriptsReducer';


import {combineReducers} from 'redux';

const rootReducer = combineReducers({
  snackbar: snackbarReducer,
  scripts: scriptsReducer,

});

export default rootReducer;
